module.exports = __webpack_public_path__ + "675ee02e3ac0b71352e6435faf649f27.jpg";